import { render, staticRenderFns } from "./ZDMFailureStatusAdmin.vue?vue&type=template&id=7d152d9c&scoped=true&"
import script from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureStatusAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d152d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
